<template>
  <div class="min-h-screen bg-carpatina-bg py-12 px-4 animate-fade-in">
    <div class="max-w-4xl mx-auto bg-white rounded-[3rem] shadow-2xl overflow-hidden border-b-8 border-carpatina-portocaliu">
      
      <div class="bg-carpatina-verde p-10 text-white relative">
        <div class="absolute top-0 right-0 p-8 opacity-10">
          <ShieldCheck :size="120" />
        </div>
        <h1 class="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-2">Politica de <span class="text-carpatina-portocaliu">Confidențialitate</span></h1>
        <p class="text-xs font-bold uppercase tracking-widest opacity-60 italic text-carpatina-gri">Actualizat la: 9 Martie 2026</p>
      </div>

      <div class="p-8 md:p-12 text-carpatina-gri leading-relaxed space-y-8 font-medium text-sm md:text-base">
        
        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 1. Ce date colectăm?
          </h2>
          <p>
            Pentru a asigura funcționarea site-ului și livrarea serviciilor, colectăm următoarele categorii de date:
          </p>
          <ul class="list-disc pl-6 space-y-2 italic text-gray-500">
            <li><strong>Date de Contact:</strong> Nume, Număr de telefon, Localitate și Mesaj (prin formularele de contact și cerere de ofertă);</li>
            <li><strong>Marketing:</strong> Adresa de email (doar dacă vă abonați explicit la Newsletter);</li>
            <li><strong>Asistent Virtual:</strong> Istoricul conversației cu asistentul nostru inteligent (stocat temporar pentru a menține contextul discuției);</li>
            <li><strong>Date Tehnice:</strong> Preferințele de navigare și produsele adăugate în coș stocate local în browserul dumneavoastră.</li>
          </ul>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 2. Cum folosim datele?
          </h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                <h4 class="font-bold text-carpatina-verde mb-2 uppercase text-xs tracking-wider">Operational & Suport</h4>
                <p class="text-xs text-gray-500">Pentru a procesa lista de ofertă, a organiza logistica de transport și a vă oferi răspunsuri rapide prin intermediul asistentului virtual.</p>
            </div>
            <div class="bg-gray-50 p-4 rounded-2xl border border-gray-100">
                <h4 class="font-bold text-carpatina-portocaliu mb-2 uppercase text-xs tracking-wider">Marketing (Opțional)</h4>
                <p class="text-xs text-gray-500">Pentru a vă trimite noutăți despre stocuri și reduceri, doar dacă v-ați dat acordul la abonare.</p>
            </div>
          </div>
        </section>

        <section class="space-y-4">
          <h2 class="text-xl font-black uppercase flex items-center gap-2 text-carpatina-verde">
            <span class="w-1.5 h-6 bg-carpatina-portocaliu inline-block"></span> 3. Cookies și Stocare Locală
          </h2>
          <p>
            Nu folosim cookie-uri invazive de tracking. Utilizăm tehnologia <strong>LocalStorage</strong> a browserului dumneavoastră strict pentru funcționalitate:
          </p>
          <ul class="list-disc pl-6 space-y-2 italic text-gray-500 text-xs">
            <li><code>carpatina_cookies</code>: Ține minte că ați acceptat această politică.</li>
            <li><code>carpatina_read_alerts</code>: Memorează ce notificări ați citit deja (clopoțelul).</li>
            <li><code>carpatina_cart</code>: Păstrează lista de materiale adăugate în coș pentru a nu fi pierdute la reîncărcarea paginii.</li>
            <li><code>carpatina_chat_history</code>: Salvează temporar conversația cu Asistentul Virtual. <strong>Datele sunt șterse automat după 30 de minute</strong> de inactivitate.</li>
          </ul>
        </section>

        <section class="space-y-4 border-t border-gray-100 pt-8">
          <div class="bg-carpatina-gri p-6 rounded-2xl text-white shadow-lg">
            <h3 class="font-black uppercase text-xs mb-3 tracking-widest text-carpatina-portocaliu text-center sm:text-left">Controlul Dumneavoastră</h3>
            <p class="text-sm opacity-80 leading-relaxed italic text-center sm:text-left mb-4">
              Aveți dreptul de a solicita ștergerea datelor (Dreptul de a fi uitat) sau dezabonarea de la Newsletter în orice moment.
            </p>
            <div class="text-center sm:text-left">
                <a href="mailto:contact@carpatina.ro" class="inline-block bg-white text-carpatina-gri px-6 py-2 rounded-xl font-bold text-xs uppercase hover:bg-carpatina-portocaliu hover:text-white transition">
                    Solicită Ștergerea Datelor
                </a>
            </div>
          </div>
        </section>

      </div>

      <div class="bg-gray-50 p-6 text-center border-t border-gray-100">
        <router-link to="/" class="text-xs font-black text-carpatina-verde hover:text-carpatina-portocaliu transition uppercase tracking-widest flex items-center justify-center gap-2">
          ← Înapoi în Site
        </router-link>
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { ShieldCheck } from 'lucide-vue-next';

onMounted(() => {
  document.title = "Politică de Confidențialitate | Carpatina Prodcom";
  
  const metaDescription = document.querySelector('meta[name="description"]') 
                          || document.createElement('meta');
  metaDescription.name = "description";
  metaDescription.content = "Află cum protejează Carpatina Prodcom datele tale personale. Informații clare despre colectarea datelor de contact pentru oferte, funcționarea coșului, a asistentului virtual și drepturile tale GDPR.";
  
  if (!document.querySelector('meta[name="description"]')) {
    document.head.appendChild(metaDescription);
  }
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.5s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>